<template>
  <RecycleScroller
    ref="scroller"
    class="cus-fixed-list"
    :items="items"
    :item-size="itemSize"
    :key-field="keyField"
    :buffer="buffer"
    :emit-update="true"
    :page-mode="false"
    @update="handleUpdate"
  >
    <template v-slot="{ item, index, active }">
      <div class="list-item-wrap" :style="wrapStyle">
        <slot :item="item" :index="index" :active="active" />
      </div>
    </template>

    <template #after>
      <div v-if="!loading && items.length === 0" class="list-empty" :style="wrapStyle">{{ emptyText }}</div>

      <div v-else-if="loading" class="list-loading" :style="wrapStyle">
        <el-button type="text" size="small" :loading="true">加载中</el-button>
      </div>

      <div v-else-if="noMore" class="list-no-more" :style="wrapStyle">没有更多了</div>
    </template>
  </RecycleScroller>
</template>

<script>
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { RecycleScroller } from "vue-virtual-scroller";

export default {
  name: "CusFixedList",
  components: {
    RecycleScroller
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    keyField: {
      type: String,
      default: "id"
    },
    buffer: {
      type: Number,
      default: 200
    },
    loading: {
      type: Boolean,
      default: false
    },
    noMore: {
      type: Boolean,
      default: false
    },
    loadMoreOffset: {
      type: Number,
      default: 2
    },
    /** 与每行实际占位高度一致；RecycleScroller 行高错误会导致点击错位、高亮跑到别的行 */
    itemSize: {
      type: Number,
      default: 76
    },
    //空数据显示的文本提示
    emptyText: {
      type: String,
      default: "暂无数据"
    }
  },
  computed: {
    wrapStyle() {
      return { height: `${this.itemSize}px` };
    }
  },
  methods: {
    handleUpdate(startIndex, endIndex, visibleStartIndex, visibleEndIndex) {
      this.$emit("update", { startIndex, endIndex, visibleStartIndex, visibleEndIndex });

      if (this.loading || this.noMore || !this.items.length) return;

      // 使用库提供的 visibleEndIndex（视口区末端，exclusive），比 buffer 的 endIndex 更准确
      const visEnd = typeof visibleEndIndex === "number" ? visibleEndIndex : endIndex;
      if (visEnd >= this.items.length - this.loadMoreOffset) {
        this.$emit("reach-bottom");
      }
    },
    scrollToItem(index) {
      if (this.$refs.scroller) {
        this.$refs.scroller.scrollToItem(index);
      }
    }
  }
};
</script>

<style scoped>
.cus-fixed-list {
  width: 100%;
  height: 100%;
  /* 禁止覆盖 vue-recycle-scroller 的 overflow-y:auto，否则滚动落在外层、scrollTop 恒为 0，无法触底加载 */
  min-height: 0;
}

.list-item-wrap {
  box-sizing: border-box;
  overflow: hidden;
}

.list-empty,
.list-loading,
.list-no-more {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 13px;
}

.list-loading >>> .el-button--text {
  color: #909399;
  padding: 0;
}

.list-loading >>> .el-button--text.is-loading:before {
  background: transparent;
}
</style>
